import React from "react";
import { Link } from "react-router-dom";
import "./CheckoutResultPage.css";

// Checkout cancel return page.
const CheckoutCancelPage = () => (
  <div className="checkout-result">
    <h1 className="cr-title">Checkout canceled</h1>
    <p className="cr-message">
      No payment was taken. You can pick a plan whenever you're ready.
    </p>
    <Link className="cr-btn" to="/pricing">
      Back to plans
    </Link>
  </div>
);

export default CheckoutCancelPage;
